import { ColumnConfig, RouteEnum } from "layout/TableConstructor/types";
import { PlatformTrialListOrderFields, TrialListQuery } from "@generated/graphql";
import dayjs from "dayjs";
import TestingStatus from "components/TestingStatus";
import DownloadReportButton from "components/buttons/DownloadReportButton";
import { CompetencyList, TrialFilter } from "pages/Testing/view/Group/components/TrialList/tableConfig/filterConfig";
import { secondsToMinutes } from "helpers/index";
import ColoredPercentage from "components/ColoredPercentage";
import typography from "constants/typography.constants";

export type TrialItem = NonNullable<NonNullable<TrialListQuery["trials"]>["data"]>[number];
type ColumnConfigItem = ColumnConfig<TrialItem, TrialFilter, PlatformTrialListOrderFields, undefined, RouteEnum.Trial>;

const columnConfig = (competencyList: CompetencyList): ColumnConfigItem[] => {
  const dynamicColumns: ColumnConfigItem[] | null = competencyList
    ? competencyList?.reduce<ColumnConfigItem[]>((acc, competency) => {
        const item: ColumnConfigItem = {
          name: `competency${competency.order}`,
          title: `Компетенция ${competency.title}`,
          render: (trial) => {
            const score = trial.competencesScore?.find((c) => c.competenceId === competency.id)?.score;
            if (typeof score !== "number") return "-";
            return score === 0 ? score : score.toFixed(1);
          },
          // @ts-expect-error надо придумать, как эо обходить, но при этом не string
          filterName: `competenceScores.${competency.id}`,
        };
        acc.push(item);
        return acc;
      }, [])
    : [];
  return [
    {
      name: "candidateNumericId",
      sortField: PlatformTrialListOrderFields.CompanyCandidateNumericId,
      title: "ID кандидата",
      render: (data) => data.companyCandidate.numericId,
      filterName: "candidateNumericId",
    },
    {
      name: "candidateFullName",
      sortField: PlatformTrialListOrderFields.CompanyCandidateFullName,
      title: "ФИО кандидата",
      render: (data) => data.companyCandidate.fullName,
      filterName: "candidateFullName",
    },
    {
      name: "completedAt",
      sortField: PlatformTrialListOrderFields.CompletedAt,
      title: "Дата окончания тестирования",
      render: (data) => (data.completedAt ? dayjs(data.completedAt).format("DD.MM.YYYY") : "-"),
      filterName: "completedAt",
    },
    {
      name: "status",
      sortField: PlatformTrialListOrderFields.Status,
      title: "Статус",
      render: (data) => <TestingStatus status={data.status} />,
      filterName: "status",
    },
    {
      title: "Время прохождения ожидаемое",
      name: "questionsTime",
      filterName: "expectedTimeOfTesting",
      render: (data) => {
        return secondsToMinutes(data.examination.questionsTime);
      },
    },
    {
      title: "Время прохождения реальное",
      name: "candidateTime",
      filterName: "timeOfTesting",
      render: (data) => {
        return secondsToMinutes(data.candidateTime);
      },
    },
    {
      name: "action",
      title: "Действие",
      render: (data) => {
        return <DownloadReportButton trial={data} />;
      },
    },
    {
      name: "score",
      title: "Общий результат",
      filterName: "candidateScore",
      render: (data) => (typeof data.candidateScore === "number" ? data.candidateScore : "-"),
    },
    {
      title: typography.testing.table.aiGenerationPercentage,
      name: "aiGenerationPercentage",
      filterName: "aiGenerationPercentage",
      render: (data) => {
        if (!data.reportData) return "-";
        return <ColoredPercentage percentage={data.reportData.ai_generation_percentage} />;
      },
    },
    ...dynamicColumns,
  ];
};

export default columnConfig;
